export default "__VITE_ASSET__BDi_$rMs__"